<div class="card"
    style="margin-bottom: 0px; margin-top: 0px;font-family: Avenir,Avenir Next,Segoe UI,Helvetica,Arial,sans-serif;">
    <div class="card-header card-chart card-header-primary">
        <div class="row">
            <div class="col-sm-12 col-md-10">
                <h4 class="card-title text-center" style="margin-left: 40px;"><b>GRAFICAS</b></h4>
            </div>
            <div class="col-sm-12 col-md-2">
                <button mat-icon-button (click)="onNoClick()">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="container">
            <div mat-dialog-content>
                <div id="seccionGraficas">
                    <div class="row">
                        <div class="col-sm-6">
                            <canvas id="graficaAvances" width="400" height="400"></canvas>
                        </div>
                        <div class="col-sm-6">
                            <canvas id="presupuestoGrafica" width="400" height="400"></canvas>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <p>Horas Autorizadas</p>
                        <h3> {{this.proyecto.horasTotales}} </h3>
                    </div>
                    <div class="col-sm-3">
                        <p>Horas Etc</p>
                        <h3> {{this.proyecto.horasEtc}} </h3>
                    </div>
                    <div class="col-sm-3">
                        <p>Horas Incurridas</p>
                        <h3> {{this.proyecto.horasTotales - this.proyecto.horasEtc}} </h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <p>Presupuesto Autorizado</p>
                        <h3> {{this.proyecto.presupuestoAutorizado}} </h3>
                    </div>
                    <div class="col-sm-3">
                        <p>Presupuesto Gastado</p>
                        <h3> {{this.proyecto.presupuestoGastado}} </h3>
                    </div>
                    <div class="col-sm-3">
                        <p>Presupuesto Restante</p>
                        <h3> {{this.proyecto.presupuestoAutorizado - this.proyecto.presupuestoGastado}} </h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 text-right">
                        <button class="btn btn-info float-right" (click)="descargarPDF()" style="margin-top: 30px;">
                            <mat-icon>get_app</mat-icon>
                            &nbsp; Descargar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>